import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-xl mb-4">
                <Link to="/" className="hover:text-accent-400 transition-colors">甜柚漫画</Link>
              </h4>
              <p className="text-sm text-background-50/80 leading-relaxed">
                甜柚漫画支持下拉式阅读，无限滚动，手机下滑畅读，竖屏下拉，免费全集漫画，热门漫画一网打尽。
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4">快速导航</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">漫画分类</Link></li>
                <li><Link to="/category/xuanhuan" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">玄幻漫画</Link></li>
                <li><Link to="/category/dushi" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">都市漫画</Link></li>
                <li><Link to="/category/lianai" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">恋爱漫画</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4">热门推荐</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/comic/7" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">九幽剑帝</Link></li>
                <li><Link to="/comic/9" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">万界神皇</Link></li>
                <li><Link to="/comic/2" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">仙武帝尊</Link></li>
                <li><Link to="/comic/4" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">末世之黑暗纪元</Link></li>
                <li><Link to="/comic/1" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">绝世神医在都市</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/about" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">品牌介绍</Link></li>
                <li><a href="#" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">用户协议</a></li>
                <li><a href="#" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">隐私政策</a></li>
                <li><a href="#" className="text-sm text-background-50/70 hover:text-accent-400 transition-colors">免责声明</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-50/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/60">
              &copy; {new Date().getFullYear()} 甜柚漫画 TianYouComics.com - 本站所有漫画均来自网络，版权归原作者所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-50/60 hover:text-accent-400 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-50/60 hover:text-accent-400 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-50/60 hover:text-accent-400 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}